var React = require('react');

function PlusCircleIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"#FFFFFF","cx":"12","cy":"12","r":"10","key":0}),React.createElement("path",{"fill":"currentColor","d":"m12 2a10 10 0 1 0 10 10 10 10 0 0 0 -10-10zm0 18a8 8 0 1 1 8-8 8.00905 8.00905 0 0 1 -8 8z","key":1}),React.createElement("path",{"fill":"currentColor","d":"M13,13h3.2c0.5,0,1-0.4,1-1s-0.5-1-1-1H13V7.7c0-0.6-0.4-1-1-1s-1,0.4-1,1V11H7.8c-0.6,0-1,0.4-1,1s0.4,1,1,1  H11v3.2c0,0.5,0.4,1,1,1s1-0.5,1-1V13z","key":2})]);
}

PlusCircleIcon.defaultProps = {"data-dmid":"dm-plus-circle","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color2"};

module.exports = PlusCircleIcon;

PlusCircleIcon.default = PlusCircleIcon;
